import { render, staticRenderFns } from "./formDialog.vue?vue&type=template&id=08f8a99c&scoped=true"
import script from "./formDialog.vue?vue&type=script&lang=js"
export * from "./formDialog.vue?vue&type=script&lang=js"
import style0 from "./formDialog.vue?vue&type=style&index=0&id=08f8a99c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f8a99c",
  null
  
)

export default component.exports